<ion-header [hidden]="!isTracker">
    <ion-toolbar>
        <ion-segment value="settings" #segment>
            <ion-segment-button value="settings">
                <ion-label> {{ 'Settings' | translate }} </ion-label>
            </ion-segment-button>
            <ion-segment-button value="admin">
                <ion-label> {{ 'Admin' | translate }} </ion-label>
            </ion-segment-button>
        </ion-segment>
    </ion-toolbar>
</ion-header>
<ion-content>
    <ion-list *ngIf="isTracker && segment.value === 'settings'">
        <ion-item button (click)="dismiss('tracking')">
            <ion-label> {{ 'Tracking mode' | translate }} </ion-label>
            <ion-icon color="secondary" slot="start" name="code-working"></ion-icon>
        </ion-item>

        <ion-item button (click)="dismiss('change-server')">
            <ion-label> {{ 'Change server' | translate }} </ion-label>
            <ion-icon color="secondary" slot="start" name="shuffle"></ion-icon>
        </ion-item>

        <ion-item button *ngIf="!isSuspended" (click)="dismiss('suspend')">
            <ion-label> {{ 'Suspend match' | translate }} </ion-label>
            <ion-icon color="secondary" slot="start" name="hourglass"></ion-icon>
        </ion-item>

        <ion-item button *ngIf="!isSuspended" (click)="dismiss('retire')">
            <ion-label> {{ 'Retire' | translate }} </ion-label>
            <ion-icon color="secondary" slot="start" name="medkit"></ion-icon>
        </ion-item>

        <ion-item button (click)="dismiss('weather')">
            <ion-label> {{ 'Weather' | translate }} </ion-label>
            <ion-badge slot="start" color="secondary">
                <span *ngIf="!match.weather?.main"> {{ 'Off' | translate }}</span>
                <span *ngIf="match.weather?.main">{{ getWeatherInfo() }}</span>
            </ion-badge>
        </ion-item>
    </ion-list>

    <ion-list *ngIf="segment.value === 'admin' || (!isTracker && isOwner)">
        <ion-item button (click)="dismiss('tracker')">
            <ion-label> {{ 'Change tracker' | translate }} </ion-label>
            <ion-icon color="secondary" slot="start" name="git-compare"></ion-icon>
        </ion-item>

        <ion-item button *ngIf="isOwner" (click)="dismiss('transfer')">
            <ion-label> {{ 'Transfer ownership' | translate }} </ion-label>
            <ion-icon color="secondary" slot="start" name="git-compare"></ion-icon>
        </ion-item>

        <ion-item button (click)="dismiss('edit')">
            <ion-label> {{ 'Edit Match' | translate }} </ion-label>
            <ion-icon color="secondary" slot="start" name="build"></ion-icon>
        </ion-item>

        <ion-item button (click)="dismiss('delete')">
            <ion-label> {{ 'Delete Match' | translate }} </ion-label>
            <ion-icon slot="start" color="danger" slot="start" name="trash"></ion-icon>
        </ion-item>

    </ion-list>
</ion-content>